import React, { Fragment } from "react";
import Edit from "../../../icons/abhi-icons/edit";
import Delete from "../../../icons/abhi-icons/delete";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateUserAction } from "../../../store/actions/UserActions";

const TableActions = ({
  i,
  d,
  formModal,
  triggerDelete,
  setShowModal,
  tableName,
  refetchData,
  isEdit = true,
  isDelete = true,
}) => {
  const dispatch = useDispatch();
  const { auth } = useSelector(state => state.auth);
  console.log('svnieosv', auth);

  const handleStatusToggle = (checked) => {
    dispatch(
      updateUserAction({
        ...d,
        status: checked ? "active" : "inactive",
        _id: d._id,
      })
    );
    if (refetchData) refetchData();
  };

  return (
    <Fragment key={i}>
      <td>
        <div className="d-flex">
          {d?._id == auth?.user?.userId ? null : (
            <>
              {isEdit && (
                <Link
                  to={formModal ? "#" : d?.audience_type == 'group' ? 'edit-group' : "edit"}
                  state={d}
                  className="btn-primary btn-xs sharp me-1"
                  onClick={() => (formModal ? setShowModal(d) : null)}
                >
                  <Edit />
                </Link>
              )}
              {isDelete && (
                <div
                  onClick={() => triggerDelete(d)}
                  className="btn-danger btn-xs sharp cursor-pointer"
                >
                  <Delete />
                </div>
              )}
            </>
          )}
          {tableName === "users" && (
            <div className="form-check form-switch ms-2">
              <input
                className="form-check-input custom-switch"
                type="checkbox"
                checked={d?.status === "active"}
                onChange={(e) => handleStatusToggle(e.target.checked)}
              />
            </div>
          )}
        </div>
      </td>
    </Fragment>
  );
};

export default TableActions;
